import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useContext } from 'react';
import AppliedFiltersContext from '~/contexts/AppliedFiltersContext';
import { useFacetData } from '~/contexts/FacetDataContext';
import FilterDrawer from './FilterDrawer';
import RangeSlider from './RangeSlider';
import useExpand from './useExpand';
import type WithClassName from './WithClassName';

export default function YearAndMileage({ className }: WithClassName) {
  const { trackEvent } = useContext(AnalyticsContext);
  const { appliedFilters, updateRangeFilter } = useContext(
    AppliedFiltersContext
  );
  const facetData = useFacetData();
  const [show, setShow] = useExpand(false);

  return (
    <FilterDrawer
      className={className}
      dataQa="facet-year-mileage"
      facetContent
      facetName="Year & Mileage"
      show={show}
      onToggle={() => {
        setShow(!show);
      }}
    >
      <div className="gap-32 grid px-24 py-32">
        <RangeSlider
          data-analytics-id="adjust-year-range"
          format="years"
          isShowing={show}
          id="facet-year"
          label="Year"
          dualRange
          min={facetData.year?.min}
          max={facetData.year?.max}
          initialValues={[
            appliedFilters.year?.min ?? facetData.year?.min ?? 0,
            appliedFilters.year?.max ?? facetData.year?.max ?? 0
          ]}
          inputWidth="80px"
          onUpdate={v => {
            updateRangeFilter({
              filterKey: 'year',
              value: {
                min: v?.[0] ?? facetData.year?.min,
                max: v?.[1] ?? facetData.year?.max
              }
            });
            trackEvent('Filter year range', {
              min: v?.[0] ?? facetData.year?.min,
              max: v?.[1] ?? facetData.year?.max
            });
          }}
        />
        <RangeSlider
          format="number"
          isShowing={show}
          id="facet-mileage"
          label="Mileage"
          dualRange
          min={facetData.mileage?.min}
          max={facetData.mileage?.max}
          initialValues={[
            appliedFilters.mileage?.min ?? facetData.mileage?.min ?? 0,
            appliedFilters.mileage?.max ?? facetData.mileage?.max ?? 0
          ]}
          inputWidth="80px"
          onUpdate={v => {
            updateRangeFilter({
              filterKey: 'mileage',
              value: {
                min: v?.[0] ?? facetData.mileage?.min,
                max: v?.[1] ?? facetData.mileage?.max
              }
            });
            trackEvent('Filter mileage range', {
              min: v?.[0] ?? facetData.mileage?.min,
              max: v?.[1] ?? facetData.mileage?.max
            });
          }}
        />
      </div>
    </FilterDrawer>
  );
}
